import { readSession, writeSession } from 'services/session/sessionStore';

// The refresh cookie is one per browser and rotates on every use, so two tabs refreshing at once
// trip the server's reuse detection and log the user out. Refreshing is therefore a critical
// section across tabs (Web Locks), and the tab that gets in re-checks the shared session first:
// if another tab already refreshed, it adopts that token instead of calling the server.
const LOCK_NAME = 'lidz-session-refresh';

export async function withRefreshLock(
  failedToken: string,
  doRefresh: () => Promise<string | null>
): Promise<string | null> {
  const run = async (): Promise<string | null> => {
    const latest = readSession();
    if (!latest) return null;
    if (latest.accessToken !== failedToken) return latest.accessToken;

    const fresh = await doRefresh();
    if (fresh) writeSession({ ...latest, accessToken: fresh });
    return fresh;
  };

  const locks = typeof navigator !== 'undefined' ? navigator.locks : undefined;
  return locks ? locks.request(LOCK_NAME, run) : run();
}
